// s117 (D529, canvas "MD Panel Add Case Drawer" P1/P2 + N1/N2, approved 2026-10-23).
// ★ A case the physician started with "Patient picks in the app" has NO area. The patient picks it from the
//   physician's areas (plus General complaint), then Describe starts. Pure (no imports), so a gate can run it.

const nameOf = (v) => (!v ? '' : typeof v === 'string' ? v : (v.name || ''))

/** True for a server case a physician holds that has no area yet and whose Describe has not begun. */
export function needsAreaPick(c) {
  if (!c || !c.id || String(c.id).startsWith('local-')) return false
  if (c.specialtyName || nameOf(c.specialty)) return false
  if (!c.heldByDoctor && !c.doctor) return false
  if (c.describeComplete || c.describe?.completed) return false
  return true
}

/** The areas a physician covers (matchFn = config/specialties doctorMatchesCategory), in catalog order. */
export function doctorAreas(areas, doctorSpecialties, matchFn) {
  const mine = (doctorSpecialties || []).filter(Boolean)
  if (!mine.length) return areas || []
  return (areas || []).filter((a) => mine.some((d) => matchFn(d, a.id)))
}

/**
 * The list with General complaint sorted in among the areas (Dr. Rami: equal weight, not a lead card): it goes
 * before the first area whose shown name sorts after it, keeping the catalog's own order otherwise.
 */
export function withGeneral(list, general, shownName) {
  if (!general) return list || []
  const g = shownName(general)
  const out = [...(list || [])]
  const at = out.findIndex((a) => shownName(a).localeCompare(g) > 0)
  out.splice(at < 0 ? out.length : at, 0, general)
  return out
}
